<template>
  <div>
    <retry v-on:retry="getLicenseInfo()" v-if="retry"></retry>
    <v-card v-else>
      <v-card-title>
        <v-icon class="mr-3" color="primary">fa-id-badge</v-icon>
        {{$t('license')}}: {{licnese}}
      </v-card-title>
      <v-card-title>
        <v-icon class="mr-3" color="primary">fa-hdd</v-icon>
        {{$t('storage')}}
      </v-card-title>
      <v-card-text>
        <v-progress-linear
          :color="usedStorageInPercentage < 50 ? 'primary': usedStorageInPercentage > 50 && usedStorageInPercentage < 75 ? 'orange' : 'red'"
          height="20"
          style="width: 100%"
          :value="usedStorageInPercentage"
        >
          <template v-slot="{ value }">
            <strong
              class="white--text"
              v-if="value >= 100"
            >{{ Math.ceil(value) }}% ({{Math.ceil(usedStorage)}} MB / {{storageLimit}} MB)</strong>
            <strong
              v-else
            >{{ Math.ceil(value) }}% ({{Math.ceil(usedStorage)}} MB / {{storageLimit}} MB)</strong>
          </template>
        </v-progress-linear>
      </v-card-text>
      <v-expand-transition>
        <div v-if="$can('update','customers') && !hasRequested">
          <div class="container black--text d-flex flex-wrap justify-space-around">
            <div class="subtitle-1 ma-1">{{$t('chooseHowMuchStorageYouWantToAdd')}}</div>
            <div>
              <v-list>
                <v-list-item-group
                  v-model="selectedUpgradeStorage"
                  :class="$vuetify.breakpoint.lgAndUp ? '' : 'flex-wrap'"
                  color="primary"
                  class="d-flex"
                >
                  <!-- <v-list-item
                    v-for="(item, i) in  storageUpgrades.filter(x => ((x.amount + storageLimit) <= customerLimit))"
                    :key="i"
                    class="d-flex v-card elevation-0 pa-0 v-card-tile v-card-border ma-1"
                  >-->
                  <v-list-item
                    class="pa-0 ma-1"
                    v-for="(item, i) in  storageUpgrades.filter(x => ((x.amount + storageLimit) <= customerLimit))"
                    :key="i"
                  >
                    <v-card class="v-card-border" elevation="0" width="100%" tile>
                      <v-card-title
                        :class="item.color ? 'secondary white--text' : 'blue-grey lighten-5'"
                      >
                        <v-icon class="mr-2" :color="item.color ? 'white' : ''" large>fa-hdd</v-icon>
                        <span>+{{item.amount / 1000}} GB</span>
                      </v-card-title>
                      <v-sheet tile color="transparent" width="300" class=" ma-6">
                        <div class="d-none display-1 font-weight-thin">
                          + {{item.price}}
                          <div class="body-1">{{$t('perMonth')}}</div>
                        </div>
                      </v-sheet>
                    </v-card>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </div>
          </div>
          <v-divider></v-divider>
          <v-card-actions v-if="selectedUpgradeStorage != null">
            <v-spacer></v-spacer>
            <!-- <areyousure2
              :headline="selectedUpgradeStorage != null ?
              `${$t('storage')}: +${storageUpgrades[selectedUpgradeStorage].amount / 1000} GB`: ''"
              :message="selectedUpgradeStorage != null ? $t('areyouSureYouWantToUpgrade')
              .replace('AMOUNT',this.storageUpgrades[selectedUpgradeStorage].amount / 1000)
              .replace('PRICE',this.storageUpgrades[selectedUpgradeStorage].price) : ''"
              :cancelbuttonText="$t('cancel')"
              :actionButtonText="$t('addStorage')"
              v-on:delete="upgradeStorage"
            > -->
            <areyousure2
              :headline="selectedUpgradeStorage != null ?
              `${$t('storage')}: +${storageUpgrades[selectedUpgradeStorage].amount / 1000} GB`: ''"
              :message="'  '"
              :cancelbuttonText="$t('cancel')"
              :actionButtonText="$t('addStorage')"
              v-on:delete="upgradeStorage"
            >
              <template v-slot:action>
                <v-btn
                  :disabled="selectedUpgradeStorage == null"
                  color="secondary"
                  depressed
                >{{$t('addStorage')}}</v-btn>
              </template>
            </areyousure2>
          </v-card-actions>
        </div>
        <!-- <div v-else class="text-center black--text pa-2">
          <v-icon color="primary" x-large>fa-check-circle</v-icon>
          <p class="mt-4">{{$t('requestReceived')}}</p>
        </div>-->
      </v-expand-transition>
    </v-card>
  </div>
</template>

<script>
import jwtdecode from "jwt-decode";
import retry from "@/components/Retry";
import areyousure2 from "@/components/AreYouSure2";
export default {
  components: {
    retry,
    areyousure2
  },
  data() {
    return {
      licnese: "",
      usedStorage: 0,
      storageLimit: 0,
      customerLimit: 40000,
      retry: false,
      selectedUpgradeStorage: null,
      hasRequested: false,
      storageUpgrades: []
    };
  },
  computed: {
    usedStorageInPercentage() {
      return (this.usedStorage / this.storageLimit) * 100;
    }
  },
  methods: {
    getUnprocessedRequest() {
      this.$http
        .getUnprocessedRequest()
        .then(res => {
          if (res.data.length > 0) {
            this.hasRequested = true;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getLicenseInfo() {
      this.$http
        .getLicenseInfo()
        .then(res => {
          this.usedStorage = parseFloat(res.data.replace(",", ""));
          this.retry = false;
        })
        .catch(err => {
          console.log(err);
          this.retry = true;
        });
    },
    getStorageUpgrades() {
      this.$http
        .getStorageUpgrades()
        .then(res => {
          this.storageUpgrades = res.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    upgradeStorage() {
      if (this.selectedUpgradeStorage == null) return;
      this.$http
        .upgradeStorage(this.storageUpgrades[this.selectedUpgradeStorage])
        .then(res => {
          localStorage.setItem("auth", res.data);
          this.$router.go();
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  watch: {
    selectedUpgradeStorage(n, o) {
      console.log(n,o)
       if (n != null) {
        this.storageUpgrades[n].color = true;
       }if
        (o != null) {
        this.storageUpgrades[o].color = false;
       }
    }
  },
  created() {
    this.licnese = jwtdecode(
      localStorage.getItem("auth")
    ).license.QRLOG.license;
    this.storageLimit = jwtdecode(
      localStorage.getItem("auth")
    ).license.QRLOG.storageLimit;
    this.getLicenseInfo();
    this.getStorageUpgrades();
  }
};
</script>

<style scoped>
.card-outter {
  position: relative;
  padding-bottom: 50px;
}
.card-actions {
  position: absolute;
  bottom: 0;
}

.v-card-border {
  border: 1px solid #0a3051;
}

.v-list-item--active,
.v-list-item--active > .v-card-border {
  border: 1px solid #009bd9 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/Users/Storage.vue